<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <div class="card">
                    <div class="card-header">Edit Roles</div>

                    <div class="card-body">

                        <ul class="nav nav-tabs">
                            <li v-for="role in roles" :class="{'active' : isActiveRole(role) }">
                                <button class="btn btn-primary" data-toggle="tab" v-on:click="changeRole(role)" style="margin:5px;">{{ role.name }}</button>
                            </li>
                        </ul>

                        <div class="tab-content">
                            <div class="tab-pane fade in active show">
                                Pick a role to start.
                            </div>
                            <div class="tab-pane fade" :class="{'in active show' : isActiveRole(role) }"
                                 v-for="role in roles">
                                <h3>{{role.name}}</h3>
                                <ul>
                                    <li v-for="permission in role.permissions">
                                        {{ permission.name }}
                                        <button class="btn btn-sm btn-warning" v-on:click="revokePermission(permission)">Revoke</button>
                                    </li>
                                </ul>
                            </div>
                            <div>
                                <h4>Add permission</h4>
                                <ul :key="JSON.stringify(permissionNotInRole)">
                                    <li v-for="permission in permissionNotInRole" >
                                        {{ permission.name }}
                                        <button class="btn btn-sm btn-primary" v-on:click="givePermission(permission)">Add</button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        /*
         * The component's data.
         */
        data() {
            return {
                activeRole: undefined,
                roles: [],
                permissions: [],
                reload: 0,
            };
        },

        /**
         * Prepare the component (Vue 1.x).
         */
        ready() {
            this.prepareComponent();
        },


        computed: {
            permissionNotInRole: function () {
                self = this;
                let permissions = this.permissions.filter(function (permission) {
                    if (self.activeRole === undefined) return true;

                    return self.activeRole.permissions.map(function (e) {
                        return e.id;
                    }).indexOf(permission.id) === -1;
                });

                let ordered = permissions.sort((a,b)=>{
                   return b.name - a.name;
                });
                return ordered;
            }
        },
        watch: {
            permissionNotInRole(newValue) {
               console.log('changed');
          },
        },
        /**
         * Prepare the component (Vue 2.x).
         */
        mounted() {
            this.prepareComponent();
        },
        methods: {
            /**
             * Prepare the component (Vue 2.x).
             */
            prepareComponent() {
                //Prepare
                this.getRoles();
                this.getPermissions();
                // this.activeRole = this.roles[0];
            },


            /**
             * Get all of the authorized tokens for the user.
             */
            getRoles() {
                this.loading = true;
                axios.get('/roles/list', {}, {
                    headers: {
                        'Content-Type': 'application/json',
                        // 'X-CSRF-TOKEN': token.content,
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                }).then(response => {
                    this.roles = response.data;
                    this.$forceUpdate();
                    this.loading = false;
                });
            },
            getPermissions() {

                axios.get('/permissions', {}, {
                    headers: {
                        'Content-Type': 'application/json',
                        // 'X-CSRF-TOKEN': token.content,
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                }).then(response => {
                    this.permissions = response.data;
                });
            },

            givePermission(permission) {

                axios.post('/roles/' + this.activeRole.id + '/permissions/add', {
                    permission_id: permission.id,
                }).then(response => {
                    this.getRoles();
                    this.reloadRole();
                });
            },

            revokePermission(permission) {
                axios.post('/roles/' + this.activeRole.id + '/permissions/' + permission.id + '/revoke')
                    .then(response => {
                        this.getRoles();
                        this.reloadRole();
                    });
            },

            isActiveRole: function (role) {
                if (this.activeRole === undefined) return false;

                return this.activeRole.id === role.id;
            },

            reloadRole(){
                let newRole;
                let self = this;
                this.roles.forEach(function(e){
                   if(e.id === self.activeRole.id){
                       newRole = e;
                   }
                });

                this.activeRole = newRole;

                this.permissions = [...this.permissions];
                this.$forceUpdate();
            },

            changeRole(role) {
                this.activeRole = role;
            },
        }
    }
</script>

<style lang="scss">

</style>
